import Plyr from 'plyr';

const selectors: Record<'video' | 'play' | 'player', string> = {
  video: '[data-video]',
  play: '[data-video-play]',
  player: '[data-video-player]',
};

const classes: Record<'isHidden', string> = {
  isHidden: 'is-hidden',
};

const initVideo = () => {
  Array.from(document.querySelectorAll(selectors.video), (video) => {
    const play = video.querySelector(selectors.play) as HTMLElement;
    const player = video.querySelector('video');
    const instance = new Plyr(player as HTMLElement, {
      clickToPlay: true,
      controls: ['progress', 'current-time', 'duration', 'fullscreen'],
      hideControls: false,
    });

    if (!play) return null;

    instance.on('playing', () => {
      play.classList.add(classes.isHidden);
    });

    instance.on('pause', () => {
      play.classList.remove(classes.isHidden);
    });

    play.addEventListener('click', () => {
      instance.play();
    });
  });
};

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    initVideo();
  },
  {
    once: true,
  }
);
